import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Single client, used everywhere — storefront and admin alike.
// Admin writes are authorized by RLS policies checking the logged-in
// Supabase Auth session, not by a separate privileged key.
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Upload a photo to Supabase Storage and return its public URL.
// Requires a public bucket named "product-images" with a storage RLS
// policy allowing INSERT for authenticated users (see admin setup SQL).
export async function uploadProductImage(file) {
  const ext = file.name.split('.').pop().toLowerCase();
  const path = `${Date.now()}_${Math.random().toString(36).slice(2)}.${ext}`;
  const { error } = await supabase.storage.from('product-images').upload(path, file, { upsert: false });
  if (error) throw new Error(error.message);
  const { data } = supabase.storage.from('product-images').getPublicUrl(path);
  return data.publicUrl;
}
